import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';

import * as S from './style';

const formatAmount = (raw: string | null) => {
	if (raw == null || raw === '') return null;
	const n = Number(raw);
	if (Number.isNaN(n)) return raw;
	return `${n.toLocaleString('ko-KR')}원`;
};

const PaymentResult = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const error = searchParams.get('error');
	const aid = searchParams.get('aid');
	const amount = searchParams.get('amount');
	const memberType = searchParams.get('member_type');
	const companyCode = searchParams.get('company_code');
	const cardNo = searchParams.get('card_no');
	const goodsType = searchParams.get('goods_type');

	const isFail = Boolean(error && error.trim() !== '') || aid === 'null';
	const isSuccess = !isFail && amount != null && amount !== '';

	const variant: 'success' | 'fail' | 'unknown' = isFail ? 'fail' : isSuccess ? 'success' : 'unknown';

	const detailNextPath = (): { label: string; path: string } | null => {
		if (!goodsType) return null;
		if (goodsType === '연회비') return { label: '연회비 안내로', path: '/membership' };
		if (goodsType === '등록비') return { label: '학술대회 안내로', path: '/society' };
		if (goodsType === '게재료') {
			return {
				label: '게재료 등록 확인',
				path: `/publication?${createSearchParams({ menu: '게재료 결제', step: '등록 확인' }).toString()}`,
			};
		}
		return null;
	};

	const next = detailNextPath();

	return (
		<S.Wrap>
			<S.Card variant={variant}>
				{isFail && (
					<>
						<S.Title>결제에 실패했습니다</S.Title>
						<S.Message>
							{(() => {
								const raw = error ?? '결제가 완료되지 않았습니다.';
								try {
									return decodeURIComponent(raw);
								} catch {
									return raw;
								}
							})()}
						</S.Message>
					</>
				)}
				{isSuccess && (
					<>
						<S.Title>결제가 완료되었습니다</S.Title>
						<S.Message>카드 결제가 정상적으로 처리되었습니다. 아래 내용을 확인해 주세요.</S.Message>
						<S.DetailList>
							{goodsType && (
								<li>
									<span className="label">결제 유형</span>
									<span>{goodsType}</span>
								</li>
							)}
							<li>
								<span className="label">결제 금액</span>
								<span>{formatAmount(amount)}</span>
							</li>
							{memberType && (
								<li>
									<span className="label">결제 시 회원 구분</span>
									<span>{memberType}</span>
								</li>
							)}
							{companyCode && (
								<li>
									<span className="label">카드사</span>
									<span>{companyCode}</span>
								</li>
							)}
							{cardNo && (
								<li>
									<span className="label">카드번호</span>
									<span>{cardNo}</span>
								</li>
							)}
						</S.DetailList>
					</>
				)}
				{!isFail && !isSuccess && (
					<>
						<S.Title>결제 창을 종료했습니다</S.Title>
						<S.Message>
							결제가 완료되지 않았거나, 중간에 취소된 경우입니다. 다시 시도하시려면 해당 메뉴에서 결제를 진행해 주세요.
						</S.Message>
					</>
				)}
			</S.Card>
			<S.ButtonRow>
				{next && <S.PrimaryButton type="button" onClick={() => navigate(next.path)}>{next.label}</S.PrimaryButton>}
				<S.SecondaryButton type="button" onClick={() => navigate('/')}>
					홈으로
				</S.SecondaryButton>
			</S.ButtonRow>
		</S.Wrap>
	);
};

export default PaymentResult;
